import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import Image from "../../../assets/secureImage.png";
import Image2 from "../../../assets/secureImage2.png";
import Image3 from "../../../assets/secureImage3.png";
import Image4 from "../../../assets/secureImage4.png";
import { Carousel } from "react-responsive-carousel";

function SecureSection() {
	return (
		<>
			<Container maxWidth="lg" id="apprentice">
				<Box
					mt={{ xs: 10, md: 5 }}
					sx={{
						display: "grid",
						gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
						gap: { xs: 4, md: 5 },
						alignItems: "center",
					}}
				>
					<Box sx={{ position: "relative" }}>
						<Box
							sx={{
								background: "rgba(188, 212, 218, 0.50)",
								height: "100%",
								width: "100%",
								borderRadius: "50%",
								filter: "blur(71px)",
								position: "absolute",
								zIndex: -1,
							}}
						/>
						<Carousel
							autoPlay
							interval={3000}
							infiniteLoop
							direction="rtl"
							showArrows={false}
							showThumbs={false}
							showIndicators={false}
							showStatus={false}
						>
							<img src={Image} alt="plane image" style={{ zIndex: 1 }} />
							<img src={Image2} alt="plane image" style={{ zIndex: 1 }} />
							<img src={Image3} alt="plane image" style={{ zIndex: 1 }} />
							<img src={Image4} alt="plane image" style={{ zIndex: 1 }} />
						</Carousel>
					</Box>
					{/* Plane  */}
					<Stack
						spacing={2}
						sx={{
							order: {
								xs: 1,
								sm: 0,
							},
						}}
					>
						<Typography
							variant="h1"
							component="h2"
							color="primary"
							sx={{ fontWeight: 600, fontSize: { xs: "32px", sm: "60px" } }}
						>
							Secure apprenticeship financing
						</Typography>
						<Typography
							variant="body1"
							color="textPrimary"
							sx={{ fontWeight: 500, fontSize: { xs: "20px", sm: "22px" } }}
						>
							Turning dreams into reality! Don&apos;t let financial barriers
							hold you back. Unlock your potential by allowing us finance your
							entrepreneurial dreams and aspirations.
						</Typography>

						<Button
							variant="outlined"
							type="button"
							sx={{ height: "50px", width: "270px" }}
						>
							Start your Financial Journey
						</Button>
					</Stack>
				</Box>
			</Container>
		</>
	);
}

export default SecureSection;
